import React, { useMemo } from 'react';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS, getCurrencySymbol, formatCompactNumber } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const AOVKPIChart: React.FC<BaseChartProps> = () => {
    const { finance, currencySettings } = useBoardChartData();

    const currencySymbol = useMemo(
        () => getCurrencySymbol(currencySettings?.default),
        [currencySettings?.default]
    );

    const aov = useMemo(() => {
        const grossSales = finance?.metrics?.grossSales ?? 0;
        const orders = finance?.metrics?.orders ?? 0;
        if (orders === 0) return 0;
        return grossSales / orders;
    }, [finance?.metrics?.grossSales, finance?.metrics?.orders]);

    const isEmpty = useMemo(() => !finance || aov === 0, [finance, aov]);

    useSetChartMetadata({ isEmpty });

    return (
        <div className="flex h-full w-full items-center justify-center [container-type:inline-size]">
            <p
                className="font-semibold text-center"
                style={{
                    color: CHART_COLORS.accent,
                    fontSize: 'clamp(1.25rem, 8cqi, 2.5rem)',
                }}
            >
                {formatCompactNumber(aov, currencySymbol)}
            </p>
        </div>
    );
};
